function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#444",
  d: "M14.834 14.161l-3.867-3.805A6.116 6.116 0 0 0 12.602 6.2c0-3.424-2.821-6.2-6.301-6.2S0 2.776 0 6.2c0 3.425 2.82 6.201 6.3 6.201 1.503 0 2.882-.52 3.966-1.385l3.881 3.82a.49.49 0 0 0 .685 0 .472.472 0 0 0 0-.675zM6.3 11.447C3.356 11.447.97 9.098.97 6.2.97 3.303 3.356.954 6.3.954c2.945 0 5.332 2.349 5.332 5.246 0 2.898-2.387 5.247-5.331 5.247z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDE1IDE1Ij4KICAgIDxwYXRoIGZpbGw9IiM0NDQiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTE0LjgzNCAxNC4xNjFsLTMuODY3LTMuODA1QTYuMTE2IDYuMTE2IDAgMCAwIDEyLjYwMiA2LjJjMC0zLjQyNC0yLjgyMS02LjItNi4zMDEtNi4yUzAgMi43NzYgMCA2LjJjMCAzLjQyNSAyLjgyIDYuMjAxIDYuMyA2LjIwMSAxLjUwMyAwIDIuODgyLS41MiAzLjk2Ni0xLjM4NWwzLjg4MSAzLjgyYS40OS40OSAwIDAgMCAuNjg1IDAgLjQ3Mi40NzIgMCAwIDAgMC0uNjc1ek02LjMgMTEuNDQ3QzMuMzU2IDExLjQ0Ny45NyA5LjA5OC45NyA2LjIuOTcgMy4zMDMgMy4zNTYuOTU0IDYuMy45NTRjMi45NDUgMCA1LjMzMiAyLjM0OSA1LjMzMiA1LjI0NiAwIDIuODk4LTIuMzg3IDUuMjQ3LTUuMzMxIDUuMjQ3eiIvPgo8L3N2Zz4K";
export { SvgComponent as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ./src/images/search.svg
// module id = 696
// module chunks = 32